// src/constants/formDefaults.js
// Centralized default values for all forms
// Single source of truth for initial form states

export const KEG_FORM_DEFAULTS = {
  kegNumber: '',
  name: '',
  owner: 'Brewer Born',
  type: 'Ball Lock',
  volume: '',
  tareWeight: '',
  features: [],
  notes: '',
  location: '',
  sublocation: ''
};

export const USER_FORM_DEFAULTS = {
  name: '',
  email: '',
  role: 'Viewer'
};

export const LOCATION_FORM_DEFAULTS = {
  name: '',
  description: '',
  hasTaps: false,
  tapCount: 0,
  tapNames: []
};

export const SUBLOCATION_FORM_DEFAULTS = {
  name: '',
  description: '',
  parentId: null,
  hasTaps: true,
  tapCount: 0,
  tapNames: []
};

export const BEER_FORM_DEFAULTS = {
  name: '',
  style: '',
  abv: '',
  ibu: '',
  og: '',
  fg: '',
  description: '',
  imageUrl: null,
  brewery: ''
};

export const MAINTENANCE_FORM_DEFAULTS = {
  date: new Date().toISOString().split('T')[0],
  items: []
};

export const RATING_FORM_DEFAULTS = {
  rating: 0,
  notes: '',
  raterName: ''
};

export const QR_SETTINGS_DEFAULTS = {
  showKegNumber: true,
  showTareWeight: false,
  showFullWeight: false
};

export const SETTINGS_DEFAULTS = {
  volumeUnit: 'gal',
  weightUnit: 'lb',
  beerDensity: 8.43,
  maintenanceIntervals: {
    'Post O-Rings': { months: 12, batches: null },
    'Poppet O-Rings': { months: 12, batches: null },
    'Lid Gasket': { months: 24, batches: null },
    'Tear Down': { months: 36, batches: null },
    'Line Cleaning': { months: 6, batches: 10 }
  }
};

export const ACCOUNT_DEFAULTS = {
  users: [],
  qrPermissions: {
    publicAccess: true,
    editableWithoutAuth: true,
    viewableWithoutAuth: true
  },
  profile: {
    name: 'Brewer Born Brewery',
    ownerName: 'Bryce',
    defaultOwner: 'Brewer Born',
    logoUrl: null
  },
  subscription: {
    plan: 'Pro',
    status: 'Active',
    nextBilling: 'Feb 1, 2026'
  }
};
